<template>
  <s-section
    class="customer-logos"
    is-sub-section
    :title="customerLogos.title"
  >
    <div
      v-if="customerLogos"
      class="customer-logos__grid"
    >
      <customer-logos-item
        v-for="customerLogo in customerLogos.items"
        :key="customerLogo.id"
        :customer-logo="customerLogo"
      ></customer-logos-item>
    </div>
  </s-section>
</template>

<script>
import CustomerLogosItem from './CustomerLogosItem'

export default {
  name: 'CustomerLogos',
  components: {
    CustomerLogosItem
  },
  props: {
    customerLogos: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style lang="scss">
.customer-logos__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 40px 0;
  margin-left: -16px;

  @media (max-width: $breakpoint-xl) {
    margin-left: 0;
  }

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: $breakpoint-md) {
    position: relative;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px 4px;
    overflow: hidden;
  }
}
</style>